export type ExitIntentPopupPosition =
  "TOP" | "CENTER" | "BOTTOM" | "FULL_SCREEN";

export interface ExitIntentPopupAspectRatio {
  width: number;
  height: number;
}

export interface ExitIntentPopupAspectRatioPair {
  mobile: ExitIntentPopupAspectRatio;
  desktop: ExitIntentPopupAspectRatio;
}

export const EXIT_INTENT_POPUP_ASPECT_RATIOS: Record<
  ExitIntentPopupPosition,
  ExitIntentPopupAspectRatioPair
> = {
  CENTER: {
    mobile: { width: 1000, height: 800 },
    desktop: { width: 1000, height: 800 },
  },
  TOP: {
    mobile: { width: 1000, height: 400 },
    desktop: { width: 1920, height: 240 },
  },
  BOTTOM: {
    mobile: { width: 1000, height: 400 },
    desktop: { width: 1920, height: 240 },
  },
  FULL_SCREEN: {
    mobile: { width: 1080, height: 1920 },
    desktop: { width: 1920, height: 1080 },
  },
};

const greatestCommonDivisor = (first: number, second: number): number =>
  second === 0 ? first : greatestCommonDivisor(second, first % second);

export const formatAspectRatio = ({
  width,
  height,
}: ExitIntentPopupAspectRatio): string => {
  const divisor = greatestCommonDivisor(width, height);
  return `${width / divisor}:${height / divisor}`;
};
